// Mobile root reducer: wraps shared reducers with offline temp-id / entity patch actions.
import Reducers from "modules/3_reducers";
import _ from "lodash";

const remergePending = (prev, next) => {
  if (!prev) return next;
  let out = next;
  _.each(prev, (sliceState, slice) => {
    if (slice === "offline_status" || slice === "current_user") return;
    if (!_.isPlainObject(sliceState) || _.isArray(sliceState)) return;
    if (!_.isPlainObject(out[slice]) || _.isArray(out[slice])) return;
    const pending = _.filter(sliceState, (row) => row && row._pendingSync && row.id != null);
    if (_.isEmpty(pending)) return;
    let merged = out[slice];
    let changed = false;
    _.each(pending, (row) => {
      if (merged[row.id] || merged[String(row.id)]) return;
      merged = { ...merged, [row.id]: row };
      changed = true;
    });
    if (changed) out = { ...out, [slice]: merged };
  });
  return out;
};

export default function mobileRootReducer(state, action) {
  let next = Reducers(state, action);

  if (action.type === "offline_temp_id_remapped") {
    const { slice, clientTempId, serverId, data } = action.payload || {};
    if (slice && next[slice]) {
      const sliceState = { ...next[slice] };
      delete sliceState[clientTempId];
      delete sliceState[String(clientTempId)];
      sliceState[serverId] = { ...data, _pendingSync: false };
      next = { ...next, [slice]: sliceState };
    }
  }

  if (action.type === "offline_entity_replaced") {
    const { slice, data } = action.payload || {};
    if (slice && slice !== "current_user" && data?.id != null && next[slice]) {
      next = {
        ...next,
        [slice]: {
          ...next[slice],
          [data.id]: { ...data, _pendingSync: !!data._pendingSync },
        },
      };
    }
  }

  if (action.type === "offline_entity_removed") {
    const { slice, id } = action.payload || {};
    if (slice && id != null && next[slice]) {
      next = { ...next, [slice]: _.omit(next[slice], [id, String(id)]) };
    }
  }

  const type = action.type || "";
  if (state && (_.startsWith(type, "get_") || _.startsWith(type, "GET_")) && _.endsWith(type, "_FULFILLED")) {
    next = remergePending(state, next);
  }

  return next;
}
